import { Component, Input, ChangeDetectionStrategy } from "@angular/core"
import { COMMON_IMPORTS } from "../common-imports"
import { Modalable } from "@app/Modalable"
import {
	SortThComponent,
	SpinOrContent,
	YesNo,
} from "@app/utils/utils.component"
import { GenAutocompleteComponent } from "@app/gen-inputs/gen-autocomplete/gen-autocomplete.component"
import { LangValPipe } from "@app/utils/lang-val.pipe"
import { DateFormatPipe } from "@app/utils/date-format.pipe"

@Component({
	selector: "app-patient-test-invites",
	imports: [
		COMMON_IMPORTS,
		SpinOrContent,
		GenAutocompleteComponent,
		SortThComponent,
		LangValPipe,
		DateFormatPipe,
		YesNo,
	],
	changeDetection: ChangeDetectionStrategy.Eager,
	template: `
		<app-spin-or-content [isSpin]="isFetching">
			@if (!patient_id) {
				<div class="row">
					<div class="col-12 col-lg-3">
						<app-gen-autocomplete
							#searchFuzzy
							title_ph_lang="patient"
							[fuzzySearchableClasses]="['patients']"
							(chosenEvent)="choosePatient($event)"
						>
						</app-gen-autocomplete>
					</div>
				</div>
			}
			<table class="table table-striped table-hover">
				<thead>
					<tr>
						@for (field of fields; track field) {
							<th
								(click)="sort(field)"
								sorter
								[fieldName]="field"
								[displayName]="field | langVal"
								[sortField]="sortField"
								[sortIsAsc]="sortIsAsc"
							></th>
						}
					</tr>
				</thead>
				<tbody>
					@for (row of objectCollectionShown; track row) {
						<tr>
							<td>{{ row.patient_name }}</td>
							<td>{{ row.test_name }}</td>
							<td>{{ row.date | dateFormat }}</td>
							<td>
								<app-yes-no
									[isCheck]="row.filled === 'yes'"
									disabled
								/>
							</td>
							<td>
								<span
									[title]="
										('sendgrid_status' | langVal) +
										':' +
										(row.notification_status | langVal)
									"
									[icon]="row.notification_status"
								></span>
							</td>
						</tr>
					}
				</tbody>
			</table>
		</app-spin-or-content>
	`,
})
export class PatientTestInvitesComponent extends Modalable {
	@Input() patient_id: number
	@Input() testschedule_id: number
	isFetching: boolean = false
	fields: string[] = [
		"patient_name",
		"test_name",
		"date",
		"filled",
		"sendgrid_status",
	]
	objectCollection: any[] = []
	objectCollectionShown: any[] = []
	sortField: string = "date"
	sortIsAsc: boolean = false

	async ngOnInit() {
		this.isFetching = true
		const res = await this.apiService.post("patient_test_invites_report", {
			patient_id: this.patient_id,
			testschedule_id: this.testschedule_id,
		})
		this.isFetching = false
		this.objectCollection = res
		if (this.patient_id) {
			this.objectCollection = this.objectCollection.filter(
				(it) => it.patient_id == this.patient_id
			)
		}
		const patients = this.store.getSiteDataTable("patients")
		const tests = this.store.getSiteDataTable("tests")

		this.objectCollection.forEach((item) => {
			item.patient_name = patients.find((it) => it.id == item.patient_id)?.name
			item.test_name = tests.find((it) => it.id == item.test_id)?.name
			item.date = new Date(item.created_at)
		})
		this.objectCollectionShown = [...this.objectCollection]
		this.search()
	}

	getDateTimeSort(a: any, b: any, factor: number) {
		return (a.date.getTime() - b.date.getTime()) * factor
	}

	sort(fieldName: string, repeatSort: boolean = false) {
		if (!repeatSort) {
			this.searchSortService.updateSortField(this, fieldName)
		}
		const reverseFactor = this.sortIsAsc ? 1 : -1

		this.objectCollectionShown.sort((a, b) => {
			if (fieldName == "date") {
				return this.getDateTimeSort(a, b, reverseFactor)
			}
			let aVal = String(a[fieldName]) || ""
			let bVal = String(b[fieldName]) || ""
			if (aVal.toLowerCase() == bVal.toLowerCase()) {
				return this.getDateTimeSort(a, b, reverseFactor)
			}
			return (aVal.toLowerCase() > bVal.toLowerCase() ? 1 : -1) * reverseFactor
		})
	}
	search() {
		this.sort(this.sortField, true)
	}
	choosePatient(obj: any = null) {
		this.objectCollectionShown = [...this.objectCollection]
		if (obj?.id) {
			this.objectCollectionShown = this.objectCollectionShown.filter(
				(row) => row.patient_id == obj.id
			)
		}
		this.sort(this.sortField, true)
	}
}
